<template>
  <FormFieldset
    :label="label"
    :patternLabel="patternLabel"
    :description="description"
    :error="error"
    :errorMessage="errorMessage"
    :req="req"
    :optional="optional"
  >
    <div class="formInput" :class="`-${size}`">
      <InputTextarea
        :id="id"
        :placeholder="placeholder"
        :error="error"
        :value="value"
        :name="name"
        :disabled="disabled"
        @call-input-change="callInputChange"
        :req="req"
      />
    </div>
  </FormFieldset>
</template>

<script lang="ts">
import FormFieldset from '@/components/block/FormFieldset.vue'
import InputTextarea from '@/components/elements/InputTextarea.vue'
import { SetupContext, reactive } from 'vue'

export default {
  name: 'FormTextareaField',

  components: {
    FormFieldset,
    InputTextarea
  },

  props: {
    id: String,
    label: String,
    patternLabel: String,
    req: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessage: String,
    description: String,
    placeholder: String,
    size: String,
    passwordSwitch: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    value: String,
    name: String
  },

  setup(props: any, context: SetupContext) {
    const input = reactive({
      type: props.type
    })

    const callInputChange = (value: string) => {
      context.emit('change-message', value)
    }

    return {
      input,
      callInputChange
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.formInput {
  min-width: 280px;

  &.-lg {
    width: 75%;
  }
}
</style>
